












































import { defineComponent, ref, PropType } from '@vue/composition-api';
import Icon from '@tt4b/ttam-assets/src/svgs/more-one.svg';
import { ActionConfig } from '../types';

const name = 'ttam-sidebar-more-actions';
export default defineComponent({
  name,
  components: {
    Icon,
  },
  props: {
    showIcons: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Array as PropType<ActionConfig[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const showActions = ref(false);

    function handleActionsShow() {
      // 阻止 click 事件向上冒泡后可以打开多个 popover，这里在打开前 body.click 一下
      document.body.click();
      showActions.value = true;
    }

    function handleActionsHide() {
      showActions.value = false;
    }

    function handleEventClick(item: ActionConfig) {
      if (item.disabled) {
        return;
      }
      emit('event-click', item.eventName);
    }

    function handleMoreClick() {
      emit('more-btn-click');
    }

    return {
      name,
      showActions,
      handleActionsShow,
      handleActionsHide,
      handleEventClick,
      handleMoreClick,
    };
  },
});
